module.exports = __webpack_public_path__ + "static/media/ic_visa.90c9a4ef.svg";